import React, { useEffect, useState } from "react";
import { useAuth } from "../../auth/FirebaseAuth.js";

import {
  adjustColorOpacity,
  darkenColor,
  getEventsByOrgRef,
  getOrgByRef,
  isColorTooDark,
  lightenColorToLuminanceAbove200,
} from "../../models/OrgFunctions.js"; // Functions to fetch org and client data

import Space from "../../layout/Space.js";
import { useTheme } from "@mui/material";
import { fr, is } from "date-fns/locale"; // Importing the French locale

import {
  getArrayDocDataByRef,
  getDocDataById,
  getDocDataByRef,
  getFlutterTimeFromSeconds,
  getOrgDataById,
  getRefFromId,
  getWorkspaceDataById,
  queryCollection,
} from "../../models/DataFunctions.js";
import { flutterColorToHex, HexColorToFlutter } from "../../config/theme.js";
import { useAppContext } from "../../config/AppContext.js";
import moment, { duration } from "moment";

import {
  format,
  addWeeks,
  subWeeks,
  startOfWeek,
  endOfWeek,
  isWithinInterval,
  set,
  lightFormat,
} from "date-fns";
import EventModal from "../EventModal.js";
import createNewEvent from "../../api/create/createNewEvent.js";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken.js";

import { useSnackbar } from "notistack";
import updateDocDataFieldApi from "../../api/database/updateDocDataFieldApi.js";
import modifyEvent from "../../api/modify/modifyEvent.js";
import SearchBarEvents from "../../textfields/SearchBarEvents.js";
import dayjs from "dayjs";
import { name } from "dayjs/locale/fr.js";
import createDocApi from "../../api/database/createDocApi.js";
import SmallSpinner from "../../loading/SmallSpinner.js";
import DropDownGPT03 from "../../dropdowns/DropDownGTP03.js";
import { PlanningEvent } from "../PlanningEvent.js";
import { PlanningHeader } from "../PlanningHeader.js";
import { isFolderClient } from "../../hexagone/VisibilityHelpers.js";
import { Spin } from "antd";
import { PlanningWeekView } from "../PlanningWeekView.js";
import { PlanningDayView } from "../PlanningDayView.js";
import { PlanningRDVHeader } from "./PlanningRDVHeader.js";
import { PlanningRDVWeekView } from "./PlanningRDVWeekView.js";
import updateDocApi from "../../api/database/updateDocApi.js";
import Icon1 from "../../icons/Icon.js";

function PlanningRDV({
  userData,
  orgData,
  navigateWorkspace,
  overrideId,
  workspaceData,
  masterData,
}) {
  const theme = useTheme();
  const { currentUser, loading } = useAuth();

  const { appState, setAppState, setEventFilter } = useAppContext();
  const saved_data = appState.saved_data;
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const searchParams = new URLSearchParams(window.location.search);
  const navigation_date = searchParams.get("date") || "";
  const folder_id = searchParams.get("folder_id") || "";
  const [searchValue, setSearchValue] = useState("");
  const [rows, setRows] = useState([]);
  const [operators, setOperators] = useState([]);

  const planning_config = appState.planning_config;
  const [selected_operators, setSelectedOperators] = useState(
    planning_config?.selected_operators &&
      planning_config.selected_operators.length > 0
      ? planning_config.selected_operators
      : ["all"]
  );
  const [clients, setClients] = useState([]);
  const [users, setUsers] = useState([]);
  const [options, setOptions] = useState([]);
  const [open, setOpen] = useState({});
  const [modal_open, setModalOpen] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [events_colors, setEventsColors] = useState(null); // State to store event colors
  const [searchEvents, setSearchEvents] = useState(true);
  const [day_view, setDayView] = useState(planning_config?.day_view || null);
  const [show_weekend, setShowWeekend] = useState(
    planning_config?.show_weekend === null
      ? true
      : planning_config?.show_weekend
  );
  const [simplified_view, setSimplifiedView] = useState(
    planning_config?.simplified_view === null
      ? false
      : planning_config?.simplified_view
  );

  const [pack_short_dict, setPackShortDict] = useState({});

  const [availalbe_slots, setAvailableSlots] = useState(null);
  const [available_slots_week_events, setAvailableSlotsEvents] = useState([]);

  const [currentWeekStart, setCurrentWeekStart] = useState(
    startOfWeek(
      navigation_date
        ? set(new Date(), {
            year: parseInt(navigation_date.split("/")[2]),
            month: parseInt(navigation_date.split("/")[1]) - 1,
            date: parseInt(navigation_date.split("/")[0]),
          })
        : planning_config
          ? planning_config.date
          : new Date(),
      {
        weekStartsOn: 1,
      }
    )
  );
  const [highligtedEvent, setHighligtedEvent] = useState(null);

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  // Helper function to get dates of the current week (Monday to Friday)
  const getCurrentWeekDates = (weekStartDate) => {
    return Array.from({ length: 7 }, (_, i) => {
      const date = new Date(weekStartDate);
      date.setDate(weekStartDate.getDate() + i);
      return date; // Return the full Date object for each day
    });
  };

  const weekDates = getCurrentWeekDates(currentWeekStart); // Get the current week's dates
  const daysOfWeek = show_weekend
    ? ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"]
    : ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi"];

  // Function to go to the previous week
  const previousWeek = async (e) => {
    e.preventDefault();
    const newWeekStart = subWeeks(currentWeekStart, 1); // Calculate the previous week
    setCurrentWeekStart(newWeekStart); // Update the state

    let new_planning_config = { ...planning_config };
    new_planning_config.date = newWeekStart;
    setAppState({
      ...appState,
      planning_config: new_planning_config,
    });

    let weekEvents = getEventsForWeek(
      all_events,
      newWeekStart,
      endOfWeek(newWeekStart, { weekStartsOn: 1 })
    );
    setEvents(weekEvents); // Filter events for the new week
    getAvailableSlotsAsWeekEvents(weekEvents, newWeekStart);

    setDate(moment(newWeekStart));
  };

  // Function to go to the previous week
  const currentWeek = async (e) => {
    e.preventDefault();

    // get the week of today
    const today = new Date();
    const newWeekStart = startOfWeek(today, { weekStartsOn: 1 }); // Calculate the previous week
    setCurrentWeekStart(newWeekStart); // Update the state

    let new_planning_config = { ...planning_config };
    new_planning_config.date = newWeekStart;
    setAppState({
      ...appState,
      planning_config: new_planning_config,
    });

    let weekEvents = getEventsForWeek(
      all_events,
      newWeekStart,
      endOfWeek(newWeekStart, { weekStartsOn: 1 })
    );
    setEvents(weekEvents); // Filter events for the new week
    getAvailableSlotsAsWeekEvents(weekEvents, newWeekStart);
    setDate(moment(newWeekStart));
  };

  const getAvailableSlotsAsWeekEvents = (
    events,
    cweekStart = currentWeekStart
  ) => {
    // based on the events in the week, get the available slots
    // create a new array of events with the start of the slot and the end of the slot
    // thoses available slots must not overlap with the events

    // slots are made of start (timestamp) and end (timestamp) and day (int 0 is monday, 6 is sunday)
    // first let's create the slots events with corresponding start and end and day
    let time_slots =
      availalbe_slots || masterData?.config?.planning?.available_slots || [];
    let exception_dates = masterData?.config?.planning?.exception_dates || [];
    let preavis = masterData?.config?.planning?.preavis || 0;

    let events_slots = [];
    for (let i = 0; i < time_slots.length; i++) {
      // we need to first get the date based on the week start date and the day int
      // then we need to get the start and end date based on the start and end timestamp
      let weekStart = new Date(cweekStart);
      weekStart.setDate(cweekStart.getDate() + time_slots[i].day); // Set the date to the correct day of the week
      // compare day and month and check if the date is in the exception dates
      let isExceptionDate = exception_dates.some((date) => {
        let exceptionDate = new Date(date.seconds * 1000);
        return (
          exceptionDate.getDate() === weekStart.getDate() &&
          exceptionDate.getMonth() === weekStart.getMonth()
        );
      });

      if (isExceptionDate) {
        continue; // Skip this slot if it's an exception date
      }

      // now we need to remove event if they are before the preavis-banned period
      let today = new Date();
      let preavisDate = new Date(
        today.getTime() + preavis * 24 * 60 * 60 * 1000
      ); // Calculate the preavis date
      if (weekStart < preavisDate) {
        continue;
      }

      // get the start of the week in seconds

      let currentWeekStartSeconds = weekStart.getTime() / 1000;

      let startDate = new Date(
        currentWeekStartSeconds * 1000 +
          time_slots[i].start.seconds * 1000 +
          3600 * 1000
      );
      let endDate = new Date(
        currentWeekStartSeconds * 1000 +
          time_slots[i].end.seconds * 1000 +
          3600 * 1000
      );

      let event_slot = {
        id: i,
        startDate: startDate,
        endDate: endDate,

        weekdate: capitalizeFirstLetter(
          format(startDate, "EEEE", { locale: fr })
        ),
        startTime: format(startDate, "HH:mm"),
        endTime: format(endDate, "HH:mm"),
        title: "",
        name: "Créneau libre",

        client_name: "",
        pack_name: "",
        pack_ref: null,
        ville: "",
      };

      events_slots.push(event_slot);
    }
    // now that we have the events slots, we need to filter them based on overlaps
    // for each slot, we need to check if it overlaps with any of the events of the week
    let filtered_slots = [];
    for (let i = 0; i < events_slots.length; i++) {
      let event_slot = events_slots[i];
      let overlap = false;
      for (let j = 0; j < events.length; j++) {
        let event = events[j];
        if (
          (event.startDate >= event_slot.startDate &&
            event.startDate <= event_slot.endDate) ||
          (event.endDate >= event_slot.startDate &&
            event.endDate <= event_slot.endDate)
        ) {
          overlap = true;
          break;
        }
      }
      if (!overlap) {
        filtered_slots.push(event_slot);
      }
    }
    // now we have the filtered slots, we need to return them
    setAvailableSlotsEvents(filtered_slots);
  };

  // Initialize state to the start of the current week (Monday)
  const [events, setEvents] = useState([]); // State to store events
  const [all_events, setAllEvents] = useState([]); // State to store all events
  // Function to go to the next week
  const nextWeek = async (e) => {
    e.preventDefault();
    const newWeekStart = addWeeks(currentWeekStart, 1); // Calculate the next week
    setCurrentWeekStart(newWeekStart); // Update the state

    let new_planning_config = { ...planning_config };
    new_planning_config.date = newWeekStart;
    setAppState({
      ...appState,
      planning_config: new_planning_config,
    });

    let weekEvents = getEventsForWeek(
      all_events,
      newWeekStart,
      endOfWeek(newWeekStart, { weekStartsOn: 1 })
    );
    const we = weekEvents;
    setEvents(we); // Filter events for the new week
    getAvailableSlotsAsWeekEvents(we, newWeekStart);
    setDate(moment(newWeekStart));
  };

  const [date, setDate] = useState(null);

  const getEventsForWeek = (all_events, weekStart, weekEnd) => {
    // Helper function to calculate the week number for a given date

    const currentWeekNumber = getWeekNumber(weekStart);

    // Weekly events occur every week
    let visible_events = all_events.filter(
      (event) =>
        isWithinInterval(event.startDate, { start: weekStart, end: weekEnd }) ||
        (isWithinInterval(event.startDate, {
          start: new Date(0),
          end: weekEnd,
        }) &&
          (event.frequency === "daily" ||
            event.frequency === "weekly" ||
            (event.frequency === "weekly2" &&
              getWeekNumber(new Date(event.start.seconds * 1000)) % 2 ===
                currentWeekNumber % 2) ||
            (event.frequency === "weekly3" &&
              getWeekNumber(new Date(event.start.seconds * 1000)) % 3 ===
                currentWeekNumber % 3) ||
            (event.frequency === "monthly" &&
              getWeekNumber(new Date(event.start.seconds * 1000)) % 4 ===
                currentWeekNumber % 4) ||
            (event.frequency === "weekly5" &&
              getWeekNumber(new Date(event.start.seconds * 1000)) % 5 ===
                currentWeekNumber % 5) ||
            (event.frequency === "weekly6" &&
              getWeekNumber(new Date(event.start.seconds * 1000)) % 6 ===
                currentWeekNumber % 6)))
    );

    return [...visible_events];
  };

  const handleGoToToday = async () => {
    const today = new Date();
    const newWeekStart = startOfWeek(today, { weekStartsOn: 1 }); // Calculate the previous week
    setCurrentWeekStart(newWeekStart); // Update the state

    let new_planning_config = { ...planning_config };
    new_planning_config.date = newWeekStart;
    setAppState({
      ...appState,
      planning_config: new_planning_config,
    });

    let weekEvents = getEventsForWeek(
      all_events,
      newWeekStart,
      endOfWeek(newWeekStart, { weekStartsOn: 1 })
    );
    setEvents(weekEvents); // Filter events for the new week
    setDate(moment(newWeekStart));
    getAvailableSlotsAsWeekEvents(weekEvents, newWeekStart);
    setDayView(new Date().getDay() - 1);
  };

  const [loadingAddingLunchBreak, setLoadingAddingLunchBreak] = useState(false);

  const [isFetching, setIsFetching] = useState(false);
  const [can_fetch, setCanFetch] = useState(true);
  useEffect(() => {
    if (currentUser) {
      handleFetchData();
    }
  }, [currentUser]);

  const handleExtraFetch = async (saved_data, masterData) => {
    if (!isFetching) {
      if (saved_data && saved_data.events) {
        if (masterData) {
          setIsFetching(true);
          await fetchAllEvents();
          setIsFetching(false);
        } else {
          setCanFetch(true);
        }
      } else {
        if (masterData) {
          setIsFetching(true);
          await fetchAllEvents();
          setIsFetching(false);
        } else {
          setCanFetch(true);
        }
      }
    }
  };

  function checkExceptionDates(eventA, eventB) {
    const dateString = new Date(
      eventA.start.seconds * 1000
    ).toLocaleDateString(); // dd/MM/yyyy
    if (
      eventA.exception_dates?.includes(dateString) ||
      eventB.exception_dates?.includes(dateString)
    ) {
      return false; // If either event has an exception date, they are not the same
    }

    return true; // No exception dates found, consider them the same
  }

  function sameMembers(event1, event2) {
    const members1 = event1?.members_id?.map((m) => m.id) || [];
    const members2 = event2?.members_id?.map((m) => m.id) || [];

    if (members1.length === 0 || members2.length === 0) {
      return false; // Both events have no members, consider them the same
    }

    members1.sort();
    members2.sort();

    const sameMembers =
      members1.length === members2.length &&
      members1.every((id, i) => id === members2[i]);
    return sameMembers;
  }

  useEffect(() => {
    // I want to know what caused the useEffect to run
    if (can_fetch) {
      setCanFetch(false);
      handleExtraFetch(saved_data, masterData);
    }
  }, [saved_data, masterData, can_fetch]);
  const [hidden_index, setHiddenIndex] = useState(0);
  const [hidden_events, setHiddenEvents] = useState([]);
  const findSuperposedEvents = (events) => {
    // First, ensure all events have valid start and end seconds
    const validEvents = events.filter(
      (event) => event.start?.seconds && event.end?.seconds
    );

    const superposedEvents = [];

    // Compare each event with all other events to find overlaps
    for (let i = 0; i < validEvents.length; i++) {
      const eventA = validEvents[i];

      for (let j = i + 1; j < validEvents.length; j++) {
        const eventB = validEvents[j];

        // Check if events overlap
        const overlap =
          ((eventA.end.seconds >= eventB.end.seconds &&
            eventA.start.seconds <= eventB.start.seconds) ||
            (eventB.end.seconds >= eventA.end.seconds &&
              eventB.start.seconds <= eventA.start.seconds)) &&
          sameMembers(eventA, eventB) &&
          checkExceptionDates(eventA, eventB);

        if (overlap) {
          // If we haven't added this event to the superposed list yet, add it
          if (!superposedEvents.includes(eventA)) {
            superposedEvents.push(eventA);
          }

          // Add the other event to the superposed list
          if (!superposedEvents.includes(eventB)) {
            superposedEvents.push(eventB);
          }
        }
      }
    }

    return superposedEvents;
  };

  const fetchAllEvents = async () => {
    try {
      let query_events = [];

      if (saved_data) {
        if (saved_data.events) {
          query_events = saved_data.events;
        }
      }

      if (query_events.length === 0) {
        let contains_workspace = location.pathname.includes("workspace");
        let workspace_id = null;
        let workspace = null;
        if (contains_workspace) {
          workspace_id = location.pathname.split("/workspace")[1].split("/")[1];
          if (workspace_id) {
            workspace = await getWorkspaceDataById(workspace_id);
          }
        }
        setEventFilter({
          org_id: masterData.id,
          type: masterData.type,
          workspace: workspace,
        });
      }

      // I want to find all events that superposed meaning event a and b have the same start.seconds and end.seconds

      let superposed = findSuperposedEvents(query_events);
      setHiddenEvents(superposed);

      // Fetch all events once from the database

      const allEvents = [];

      if (!workspaceData) {
        const filters = [
          {
            field: "masters_id",
            operator: "array-contains",
            value: masterData.id,
          },
        ];
        const clients = await queryCollection("org", filters);
        setClients(clients);
      }

      for (const event of query_events) {
        if (event.start.seconds && event.end.seconds) {
          // Convert Firestore Timestamps to Date
          const startDate = new Date(event.start.seconds * 1000);
          const endDate = new Date(event.end.seconds * 1000);

          let dict_event = event;

          dict_event.startDate = startDate; // Store the full date object to filter later
          dict_event.endDate = endDate;

          dict_event.weekdate = capitalizeFirstLetter(
            format(startDate, "EEEE", { locale: fr })
          );
          dict_event.startTime = format(startDate, "HH:mm");
          dict_event.endTime = format(endDate, "HH:mm");
          dict_event.title = event.title || "Titre";
          dict_event.name = event.name || "Titre";

          dict_event.client_name = event.client_name || "";
          dict_event.pack_name = event.pack_name || "";
          dict_event.pack_ref = event.pack_ref;
          dict_event.ville = event.ville || "";

          allEvents.push(dict_event);
        }
      }
      setAllEvents(allEvents); // Store all events in state

      const the_events = allEvents;

      const open_events_dict = the_events.reduce((acc, event) => {
        acc[event.id] = open[event.id] || false;
        return acc;
      }, {});
      setOpen(open_events_dict);

      const newWeekStart = subWeeks(currentWeekStart, 0); // Calculate the previous week

      let new_planning_config = { ...planning_config };
      new_planning_config.date = newWeekStart;
      setAppState({
        ...appState,
        planning_config: new_planning_config,
      });

      setCurrentWeekStart(newWeekStart); // Update the state
      const weekevents = getEventsForWeek(
        allEvents,
        newWeekStart,
        endOfWeek(newWeekStart, { weekStartsOn: 1 })
      );
      const weekagendaevents = weekevents;
      setEvents(weekagendaevents); // Filter events for the current week
      getAvailableSlotsAsWeekEvents(weekagendaevents, newWeekStart);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSetDayView = (index) => {
    let new_day_view = index;
    setDayView(new_day_view);
    let new_planning_config = { ...planning_config };
    new_planning_config.day_view = new_day_view;
    setAppState({
      ...appState,
      planning_config: new_planning_config,
    });
  };

  // Fun
  // Generate time intervals dynamically from 07:00 to 21:00
  const timeSlots = [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]; // Time slots for the scheduler

  // Helper function to convert time (HH:mm) to minutes since the start of the day
  // Helper function to convert time (HH:mm) to minutes since the start of the day
  const timeToMinutes = (time) => {
    if (!time) return 0; // If time is undefined or null, return 0 (or handle as needed)

    const [hours, minutes] = time.split(":").map(Number); // Safely split the time
    return hours * 60 + minutes;
  };
  const [operator_colors, setOperatorColors] = useState({});

  // If client exists, navigate to the client page by ID

  // Function to navigate to a client by ID

  const [newEventPlacement, setNewEventPlacement] = useState(null);
  const handleAddEventBasedOnSlot = async (slot_event) => {
    if (!masterData) {
      return;
    }

    setNewEventPlacement(false);
    let day_index = slot_event.startDate.getDay();

    let starthour = slot_event.startDate.getHours();
    let endhour = slot_event.endDate.getHours();
    let startmin = slot_event.startDate.getMinutes();
    let endmin = slot_event.endDate.getMinutes();
    let parsedDate = format(slot_event.startDate, "dd/MM/yyyy", { locale: fr });

    const event_id = await createNewEvent(
      starthour,
      endhour,
      startmin,
      endmin,
      parsedDate, // The full date in "dd/MM/yyyy" format
      "", // Placeholder event name (you can change this)
      "", // Placeholder event description (you can change this)
      masterData.id,
      prefix
    );
    if (!event_id) {
      handleClickVariant("Hors des heures de travail", "error");
      return;
    }
    const eventRef = getRefFromId("event", event_id);
    if (
      selected_operators &&
      selected_operators.length > 0 &&
      selected_operators[0] !== "all"
    ) {
      let member = selected_operators[0];
      let member_ref = getRefFromId("user", member);
      await updateDocDataFieldApi(eventRef, "members", [member_ref], prefix);
    }
    if (day_view !== null && operator_id !== null) {
      let member_ref = getRefFromId("user", operator_id);
      await updateDocDataFieldApi(eventRef, "members", [member_ref], prefix);
    }

    const newEvent = await getDocDataByRef(eventRef);
    let folder = await getDocDataById("folder", folder_id);
    if (folder) {
      await onCreate(newEvent, folder);
    } else {
      handleClickVariant("Le dossier n'existe pas", "error");
      navigateWorkspace("/folders");
    }
  };

  function getWeekNumber(d) {
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
    return weekNo;
  }

  const onCreate = async (event, folder) => {
    try {
      const startDate = new Date(event.start.seconds * 1000);
      const endDate = new Date(event.end.seconds * 1000);

      const client = folder?.client_id
        ? await getOrgDataById(folder.client_id)
        : null;
      const dict_event = {
        id: event.id,
        start: event.start, // Store the full date object to filter later
        end: event.end,
        date: event.date,
        weekdate: capitalizeFirstLetter(
          format(startDate, "EEEE", { locale: fr })
        ),
        startTime: format(startDate, "HH:mm"),
        endTime: format(endDate, "HH:mm"),
        title: event.title || "Titre",
        titre_auto: event.titre_auto,
        description: event.description,
        address: event.address,
        client_name: client ? client.name : event.client_name,
        client_id: folder ? folder.client_id : event.client_id,
        color: event.color,
        duration: event.duration,
        folder: folder ? folder.ref : event.folder,
        link: event.link,
        mandataire_auto: event.mandataire_auto,
        members: event.members_id,
        name: event.name || "Titre",
        nom_auto: event.nom_auto,
        num_particulier: event.num_particulier,
        pack_name: folder ? folder.pack_name : event.pack_name,
        pack_ref: folder ? folder.pack_ref : event.pack_ref,
        rappels: event.rappels,
        ville: folder ? folder.ville : event.ville,
        revision: event.revision,
        exception_dates: [],
      };

      if (folder) {
        const token = await getOrRefreshFirebaseToken();
        setCanFetch(true);
        await modifyEvent(
          [],
          event.start,
          event.end,
          event.date || "",
          event.pack_name || "",
          event.pack_ref,
          event.link || "",
          event.mandataire_auto || true,
          event.nom_auto || true,
          event.titre_auto || true,
          event.name || "Titre",
          client?.id || "",
          event.emails || [],
          event.num_particulier || "",
          event.msg_content || "",
          folder.nom +
            " " +
            client?.name +
            " " +
            folder.pack_name +
            " " +
            folder.ville,
          event.address || "",
          event.ville || "",
          event.postal || "",
          event.description || "",
          folder.id || "",
          event.conductor_id || "",

          event.id || "",
          event.documents_completed || false,
          event.rdv_confirmed || false,
          event.type || "Intervention",
          event.frequency || "",
          [],
          token,
          prefix
        );
      }

      if (folder) {
        const eventRef = getRefFromId("event", event.id);
        let rdv_state = "done";
        await updateDocApi(
          folder.ref,
          {
            event_ref: eventRef,
            rdv_state: rdv_state,
          },
          prefix
        );
      }

      handleClickVariant("Évènement créé", "success");
      navigateWorkspace("/folder/" + folder_id);
    } catch (error) {
      console.error("Error creating event:", error);
      handleClickVariant("Erreur lors de la création de l'évènement", "error");
    }
  };

  const handleOpenModal = async (event_id) => {
    let chosen_slot_event = available_slots_week_events.find(
      (event) => event.id === event_id
    );
    await handleAddEventBasedOnSlot(chosen_slot_event);
    // now we need to create a real event based on the start and end date of the chosen slot
  };
  const handleCloseModal = () => {};
  const onDelete = async (event) => {};
  useEffect(() => {
    setOptions(
      all_events.map((event) => ({
        value: event.id,
        label: event.name,

        extra_label: event.client_name,
        extra_label_2: event.revision ? "Revisite " + event.revision : "",
        client_type: event.client_type,
      }))
    );
  }, [all_events, searchEvents]);

  // Function to fetch data for the current user
  const handleFetchData = async () => {
    if (masterData) {
      const available_slots =
        masterData.config?.planning?.available_slots || [];
      setAvailableSlots(available_slots);

      // Update state if the user data is new or changed
    }
  };
  const [display_rdv_tuto, setDisplayRDVTuto] = useState(true);
  const [height, setHeight] = useState(simplified_view ? 700 : 1700);
  useEffect(() => {
    setHeight(simplified_view ? 700 : 1700);
  }, [simplified_view]);
  function getYPosition(minutes) {
    let top = (height * (minutes - 478)) / 12450;
    let before8h = minutes < 480;
    let after20h = minutes > 1200;
    return before8h ? 0 : after20h ? 0 : top;
  }
  function getHeight(minutes) {
    let event_h = height * (minutes / 12450);
    return event_h;
  }

  // Fetch data when the component mounts or when currentUser changes

  // If the data is still loading or the user is not authenticated, show a loading message
  //loading || !currentUser || !userData
  if (loading || !currentUser || !userData) {
    return (
      <div className="h-full w-full pl-4 flex flex-col gap-2">
        <SmallSpinner spinning={true} size="small" />
      </div>
    );
  }

  // Render the client data
  return (
    <div
      className={`flex flex-col px-4 w-full h-full max-h-full  overflow-y-auto pb-20   bg-white rounded-xl`}
    >
      <div className=" font-medium text-hx text-black mb-3 select-none pt-2">
        Prise de rendez-vous
      </div>

      <div className=" relative">
        {display_rdv_tuto && (
          <div className="absolute top-20  z-50 hover:animate-none items-center left-20 w-fit shadow-xl shadow-cyan-200 bg-black p-6 rounded-2xl text-white flex flex-row gap-2">
            <div className="text-h3 w-c300">
              Sélectionnez un créneau libre pour créer un rendez-vous
            </div>
            <div
              className="cursor-pointer z-50"
              onClick={() => {
                setDisplayRDVTuto(false);
              }}
            >
              <Icon1
                hover_color={"red"}
                icon_name="close"
                size={20}
                fill="white"
              ></Icon1>
            </div>
          </div>
        )}
      </div>

      <div className=" flex flex-col rounded-md w-full min-h-fit  pb-4 ">
        <PlanningRDVHeader
          handleSetDayView={handleSetDayView}
          handleClick={() => {}}
          handleGoToToday={handleGoToToday}
          show_weekend={show_weekend}
          setShowWeekend={setShowWeekend}
          appState={appState}
          setAppState={setAppState}
          planning_config={planning_config}
          modal_open={modal_open}
          day_view={day_view}
          currentWeekStart={currentWeekStart}
          previousWeek={previousWeek}
          nextWeek={nextWeek}
          currentWeek={currentWeek}
          weekDates={weekDates}
          orgData={orgData}
          getWeekNumber={getWeekNumber}
          daysOfWeek={daysOfWeek}
          simplified_view={simplified_view}
          setSimplifiedView={setSimplifiedView}
          workspaceData={workspaceData}
        ></PlanningRDVHeader>
        <div className=" bg-transparent   rounded-md w-full min-h-fit ">
          <div className="flex flex-row  w-full min-h-fit ">
            <div className="flex flex-col w-10  " style={{ marginTop: "13px" }}>
              {timeSlots.map((hour, index) => (
                <div
                  key={hour + index.toString()}
                  className="bg-transparent border-t-2 border-r-2 border-wshadow_25 w-10  select-none flex flex-col   font-light h-full p-2 text-h4 text-black justify-start"
                >
                  <div className="flex flex-col">
                    {" "}
                    <div className=" w-full h-full flex justify-center">
                      {hour}h
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <PlanningRDVWeekView
              events={available_slots_week_events}
              timeSlots={timeSlots}
              handleClick={() => {}}
              handleOpenModal={handleOpenModal}
              handleCloseModal={handleCloseModal}
              open={open}
              highligtedEvent={highligtedEvent}
              day_view={day_view}
              daysOfWeek={daysOfWeek}
              weekDates={weekDates}
              height={height}
              events_colors={events_colors}
              pack_short_dict={pack_short_dict}
              simplified_view={simplified_view}
              masterData={masterData}
              orgData={orgData}
              userData={userData}
              selected_operators={selected_operators}
              onDelete={onDelete}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
              getYPosition={getYPosition}
              getHeight={getHeight}
              setHighligtedEvent={setHighligtedEvent}
              timeToMinutes={timeToMinutes}
            ></PlanningRDVWeekView>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlanningRDV;

export function capitalizeFirstLetter(string) {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
}
